import { missionApiClient } from "../../services/apiClient";

export interface ImportMissionsResponse {
    message: string;
    count: number;
}

/**
 * Importe un fichier Excel de missions
 * @param file - Fichier Excel à importer
 */
export async function importMissions(file: File): Promise<ImportMissionsResponse> {
    const formData = new FormData();
    formData.append("file", file);

    const response = await missionApiClient.post<ImportMissionsResponse>(
        "/missions/import",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );

    return response.data;
}